import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapCollection } from '../ruutsApi/normalize'
import { getFrontPaddocks } from './getPaddocks'

// `id` may be a single id or an array of ids — the v1 list endpoint resolves both in one request.
export async function getPaddockById({ id, signal }) {
  const response = await apiClient.get(endpoints.paddocks, { params: { id }, signal })
  return getFrontPaddocks(unwrapCollection(response))
}
